import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>();

  const media = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

  const onMediaChange = () => {
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
  };

  useEffect(() => {
    onMediaChange();

    media.addEventListener("change", onMediaChange);
    return () => {
      media.removeEventListener("change", onMediaChange);
    };
  }, [media]);

  return !!isMobile;
}
